import { formatCurrency, formatLocaleCurrency } from '@tidal/country-currency-map';

/** @type {import("@nuxt/types").Plugin} */
export default function(_ctx, inject) {
    inject('currency', { formatCurrency, formatLocaleCurrency });
}
